import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import LeadForm from '@/components/shared/LeadForm';
import { ShieldCheck, Clock, CheckCircle } from 'lucide-react';

export default function PopupForm({ isOpen, onClose, packageInfo }) {
  const isPackage = !!packageInfo?.title;

  return (
    <Dialog open={isOpen} onOpenChange={(open) => { if (!open) onClose(); }}>
      <DialogContent
        className="sm:max-w-lg p-0 rounded-none border-0 overflow-hidden"
        data-testid="popup-form-dialog"
      >
        {/* Top accent bar */}
        <div className="h-1.5 bg-[#002FA7]" />

        <div className="px-8 pt-6 pb-8">
          <DialogHeader className="mb-6">
            <DialogTitle className="font-heading font-black text-2xl tracking-tight text-[#09090B]">
              {isPackage ? `Get the ${packageInfo.title} Package` : 'Protect Your Brand Today'}
            </DialogTitle>
            <DialogDescription className="text-sm text-zinc-500 font-body mt-1">
              {isPackage
                ? `Starting at ${packageInfo.amount > 0 ? `$${packageInfo.amount}` : ''} + federal filing fee. Complete the form to get started.`
                : 'Fill in your details below and our trademark specialists will reach out within 24 hours to assist you.'}
            </DialogDescription>
          </DialogHeader>

          <LeadForm
            packageTitle={packageInfo?.title || ''}
            packageAmount={packageInfo?.amount || 0}
            buttonText={isPackage ? `Claim ${packageInfo.title} Package` : 'Get Started Now'}
            onSuccess={onClose}
          />

          {/* Trust indicators */}
          <div className="mt-6 pt-5 border-t border-zinc-100">
            <div className="flex items-center justify-center gap-6 text-zinc-400">
              <div className="flex items-center gap-1.5">
                <ShieldCheck className="w-3.5 h-3.5" />
                <span className="text-[11px] font-body">Secure & Confidential</span>
              </div>
              <div className="flex items-center gap-1.5">
                <Clock className="w-3.5 h-3.5" />
                <span className="text-[11px] font-body">24hr Response Time</span>
              </div>
              <div className="flex items-center gap-1.5">
                <CheckCircle className="w-3.5 h-3.5" />
                <span className="text-[11px] font-body">No Obligation</span>
              </div>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
